import { Button } from '../Input2';
import { General } from '../StrokeIcons';
import Popup, { PopupProps } from './Popup';

type CadenceDeletePopupProps = PopupProps & {
  onClose: () => void;
  onSubmit: () => void;
};

export default function MarkDonePopup({ onClose, onSubmit }: CadenceDeletePopupProps) {
  return (
    <Popup onClose={onClose} className="max-w-lg">
      <h2 className="text-xl font-bold dark:text-gray-100">Are you sure?</h2>

      <p>This action can not be undone</p>
      <Button icon={<General.CheckCircle />} color="blue" onClick={onSubmit}>
        Yes, I have done these tasks
      </Button>
    </Popup>
  );
}